import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import CommitActivityStats from "./commit-stats";
import "./index.css";

class GithubCommitActivity extends Component {
  render() {
    return (
      <div
        className="github-stats-column h-100 p-3"
        style={{
          background: "var(--cardBg)",
          border: "var(--card-border)",
          transition: "color 0.2s ease-out, background 0.2s ease-out"
        }}
      >
        <div className="d-flex justify-content-between mb-3">
          <span className="badge badge-warning market-bedge">
            GitHub Commit Activity
          </span>
          <img
            className="img-fluid"
            src={require("../../../assets/icons/share-icon.svg")}
            alt="share"
          />
        </div>
        <h3
          className="github-stats-col-heading text-left"
          style={{
            color: "var(--h3Color)",
            transition: "color 0.2s ease-out, background 0.2s ease-out"
          }}
        >
          <span className="first-text">idni / tau</span>
          <span className="agoras-icon">
            <img
              className="img-fluid github-icon pl-2 pr-2"
              src={require("../../../assets/icons/github-icon.png")}
              style={{ filter: "var(--github-icon)" }}
              alt="Github"
            />
          </span>
        </h3>

        <div className="market-inner-col d-flex justify-content-between">
          <span
            className="currency-row"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            Sector : <span className="currency-text">Stats</span>
          </span>
          <span
            className="currency-row"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            Category : <span className="currency-text">Development</span>
          </span>
        </div>

        <div className="row mt-3 mb-3">
          <div className="col-12">
            <CommitActivityStats />
          </div>
        </div>

        <div className="row">
          <div className="col github-commits text-center">
            <FontAwesomeIcon
              icon={faCircle}
              className="faCircle github-commits-icon"
            />
            <span style={{ color: "var(--social-widget-name)" }}>commits</span>
          </div>
        </div>
      </div>
    );
  }
}

export default GithubCommitActivity;
